import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {RouterOutletWrapperComponent} from './router-outlet-wrapper/router-outlet-wrapper.component';
import {PathwaysModule} from '@ispm-client/modules/pathways';
import {ConfigurationModule} from '../../../configuration/configuration.module';

@NgModule({
  imports: [
    RouterModule,
    ConfigurationModule,
    PathwaysModule.forRoot(),
    RouterModule.forRoot([])
  ],
  declarations: [RouterOutletWrapperComponent],
  providers: []
})
export class PathwaysWrapperModule {
}
